import React from "react";

export default function Error() {
  return (
    <div
      style={{
        textAlign: "center",
        width: "100%",
        marginTop: "150px",
        display:'inline-block'
      }}
    >
      <img
        src="https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgW9PA6pkhTw32vZcnXT5dPfNjkdHHsnaVZrkKzQoFmMmABeTwvaUjUvQ_k2PvpwTjJwjYWswVRYJe--V1iL7aWd_1bnLwaOnTPeoZVuoEExkpUjGdcdXkzwQ2-RtsJbw9Q4YuLJ9jSmOt4ijP8BYEpOpQ8Os6nZGSmZVidorW_qMJIDWvMkYXICXoj/s16000/404%20Page%20Not%20Found.png"
        alt="errorpage_img"
        style={{
          width: "50vw",
          objectFit: "cover",
          borderRadius: "20px",
          boxShadow: "0px 5px 25px white",
        }}
        className="animate__animated animate__flipInX"
      />
    </div>
  );
}
